<app-page-shell variant="default">
<div class="widget-setting">

    <app-sb-input-form
      title="Widget settings"
      [stickyFooter]="true">
        <div class="row" *ngIf="globalWidget">
          <div class="col-md-12 mb-3">
            <div class="alert alert-info mb-0">
              Global Widget
              <a
                class="alert-link"
                [routerLink]="['/global-widgets', globalWidget.id, 'edit']"
                sbEntityLink>
                <strong>{{globalWidget.name}}</strong>
              </a>
              (<code>{{globalWidget.code}}</code>) is automatically applied to this project.
            </div>
          </div>
        </div>
        <div class='row'>
          <div class='col-md-12 mb-3 mx-auto'>
            <div class="text-info">To encourage new registrants to quickly engage with the campaign and start promoting it right after they register, we offer a special widget to be displayed on the registration confirmation page (thank you page). The widget automatically registers the new user on Snöball and generates his/her landing page.
              <br />
              <a href="https://i.snoball.local/share/c/V5p" target="_blank" rel="noopener">View an example</a>
            </div>
          </div>
        </div>
        <ng-template #useGlobalSetting let-key="key">
          <div class="widget-setting-meta widget-use-global-control" *ngIf="globalWidget">
            <button type="button"
                    class="widget-use-global-button"
                    [class.active]="isGlobalSettingInherited(key)"
                    [attr.aria-pressed]="isGlobalSettingInherited(key)"
                    (click)="toggleGlobalSetting(key, !isGlobalSettingInherited(key))">
              <i class="fa fa-link" aria-hidden="true"></i>
              <span>Use Global</span>
            </button>
            <ng-container *ngIf="isGlobalWidgetRichTextValue(key); else inlineGlobalValue">
              <ng-container *ngIf="hasGlobalWidgetRichTextValue(key); else emptyGlobalRichTextValue">
                <span class="global-value-popup-control">
                  <span>Global value:</span>
                  <button type="button"
                          class="global-value-popup-button"
                          aria-label="View global value"
                          title="View global value"
                          placement="top"
                          container="body"
                          [autoClose]="'outside'"
                          [popoverClass]="'global-widget-rich-text-popover'"
                          [ngbPopover]="globalRichTextValue">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </button>
                </span>
                <ng-template #globalRichTextValue>
                  <div class="global-widget-rich-text-content"
                       [innerHTML]="getGlobalWidgetFormattedValue(key)">
                  </div>
                </ng-template>
              </ng-container>
              <ng-template #emptyGlobalRichTextValue>
                <span>Global value: Not set</span>
              </ng-template>
            </ng-container>
            <ng-template #inlineGlobalValue>
              <span>Global value: {{getGlobalWidgetValueLabel(key)}}</span>
            </ng-template>
          </div>
        </ng-template>
        <fieldset>
          <legend>Activate</legend>
          <div class='row'>
            <div class='col-md-11 mx-auto customize-email'>
              <input id="customizePage" placeholder="" type="checkbox"
                     [(ngModel)]="projectMeta['active']"
                     [disabled]="isGlobalSettingInherited('active')">
              <label for="customizePage">Widget Active</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'active'}"></ng-container>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Linked Campaign: New registrations will be added to the following campaign (Mandatory)</small>
              </div>
              <div class="client-dropdown">
                <app-creatable-select
                  [isDisabled]="!projectMeta['active']"
                  [selectedValue]="projectMeta['default_new_register_campaign_id']"
                  [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                  [placeholder]="'Select Default Campaign'" [selectOptions]="campaigns"
                  (optionSelected)="projectMeta['default_new_register_campaign_id'] = ($event ? $event.value: null)"></app-creatable-select>
              </div>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Linked Conditional Campaign: This can be used for new registrations in special cases defined in custom script section (Ignore if you don't know what this is)</small>
              </div>
              <div class="client-dropdown">
                <app-creatable-select
                  [isDisabled]="!projectMeta['active']"
                  [selectedValue]="projectMeta['conditional_new_register_campaign_id']"
                  [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                  [placeholder]="'Select Conditional Campaign'" [selectOptions]="campaigns"
                  (optionSelected)="projectMeta['conditional_new_register_campaign_id'] = ($event ? $event.value: null)"></app-creatable-select>
              </div>
            </div>
          </div>
          <div class='row' *ngIf="!globalWidget">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="row">
                <div class="client-dropdown" [ngClass]="currentUser?.can( 'view-client-column', 'project-ui') ? 'col-ld-10 col-md-10' : 'col-ld-12 col-md-12'">
                  <small class="text-capitalize">Registration Platform (We already support several different registration platforms, if you find yours and select it here it makes the integration much easier)</small>
                  <app-creatable-select
                    [isDisabled]="!projectMeta['active'] || isGlobalSettingInherited('registration_platform_id')"
                    [labelKey]="'platform_name_with_support'"
                    [selectedValue]="projectMeta['registration_platform_id']"
                    [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                    [placeholder]="'Select Registration Platforms'" [selectOptions]="registrationPlatforms"
                    (optionSelected)=onSelectRegistrationPlatform($event)
                  ></app-creatable-select>
                  <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'registration_platform_id'}"></ng-container>
                </div>
                <div *ngIf="currentUser?.can( 'view-client-column', 'project-ui')" class="col-lg-2 col-md-2">
                  <button class="btn btn-sm btn-primary" type="button" (click)="showAddPlatformPopup()" role="button">
                    <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
                    <span class="btn-wrapper--label">Add New Platform</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Note (Can include info about special consideration regarding the widget or its integration like for example PromoCodes for testing, where it might have been added in your site, etc)</small>
              </div>
              <div class='input-group input-group-sm variable-textarea'>
                <div [attr.data-replicated-value]="projectMeta['note']" class="grow-wrap" style="width: 100%">
                <textarea onInput="this.parentNode.dataset.replicatedValue = this.value" class="form-control" rows="6" [(ngModel)]="projectMeta['note']"
                          [disabled]="!projectMeta['active'] || isGlobalSettingInherited('note')">{{projectMeta['note']}}</textarea>
                </div>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'note'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Project Code (This is mostly useful when the widget is already integrated in your site in a generic way and all you need is to just add the project code somewhere in your platform's setting)</small>
              </div>
              <div class='input-group input-group-sm project-code'>
                <input class="form-control code" id="project_code" [value]="project?.code" [readOnly]="true"/>
                <span class="copy-clipboard"><i (click)="copyProjectCode(project?.code)" class="fa fa-clone"></i></span>
              </div>
            </div>
          </div>
          <div class='row mb-2'>
            <div class='col-md-11 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Now that you've set the settings, have a look at the detailed generated instruction on how to add the widget.</small>
              </div>
              <a class="" style="color: #4BB7E3; cursor: pointer"
                 (click)="showWidgetInstructions(widgetInstructions)"><i class="fa fa-question-circle"></i> Widget
                integration instructions</a>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <legend>Influencer Picture and Info</legend>
          <div class='row'>
            <div class='col-md-11 mb-3 mx-auto customize-email'>
              <input id="allow_influencers_to_edit_primary_info" placeholder="" type="checkbox"
                     [(ngModel)]="projectMeta['allow_influencers_to_edit_primary_info']" [disabled]="!projectMeta['active']">
              <label for="allow_influencers_to_edit_primary_info">Allow influencer to edit his/her primary info through the widget</label>
            </div>
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">A picture button will be displayed on the share widget for the campaign that's linked to the widget. Influencer will be able to update their picture through a popup and see the result on the share image.</small>
              </div>
              <div class='input-group input-group-sm customize-email'>
                <input id="allow_influencers_to_update_their_picture_in_widget" placeholder="" type="checkbox" value="true"
                       [(ngModel)]="projectMeta['allow_influencers_to_update_their_picture_in_widget']" [disabled]="!projectMeta['active']">
                <label for="allow_influencers_to_update_their_picture_in_widget" style="margin: 0 0 0 5px;">Allow influencers to update their picture</label>
                <button type="button"
                        class="widget-advanced-link ml-3"
                        (click)="openWidgetAdvancedSettings(advancedImageSettingsModal)"
                        [disabled]="!projectMeta['active']">
                  Advanced Settings
                </button>
              </div>
            </div>
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">A video button will be displayed on the share widget for the campaign that's linked to the widget. Influencers will be able to update their video through the widget.</small>
              </div>
              <div class='input-group input-group-sm customize-email'>
                <input id="allow_influencers_to_update_their_video_in_widget" placeholder="" type="checkbox" value="true"
                       [(ngModel)]="projectMeta['allow_influencers_to_update_their_video_in_widget']" [disabled]="!projectMeta['active']">
                <label for="allow_influencers_to_update_their_video_in_widget" style="margin: 0 0 0 5px;">Allow influencers to update their video</label>
                <button type="button"
                        class="widget-advanced-link ml-3"
                        (click)="openWidgetAdvancedSettings(advancedVideoSettingsModal)"
                        [disabled]="!projectMeta['active']">
                  Advanced Settings
                </button>
              </div>
            </div>
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">When uploading their picture through widget upload picture, users will also have the option to use Avatar AI to style their picture and use that as their picture instead</small>
              </div>
              <div class='input-group input-group-sm customize-email'>
                <input id="allow_influencers_to_use_ai_avatar_in_widget" placeholder="" type="checkbox" value="true"
                       [(ngModel)]="projectMeta['allow_influencers_to_use_ai_avatar_in_widget']" [disabled]="!projectMeta['allow_influencers_to_update_their_picture_in_widget'] || !projectMeta['active']">
                <label for="allow_influencers_to_use_ai_avatar_in_widget" style="margin: 0 0 0 5px;">Allow influencers to use AI to generate their Picture/Avatar</label>
              </div>
            </div>
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="col-md-6 col-sm-12 p-0">
                <ul class="avatar-template-menu-items p-0">
                  <li class="dropdown avatar-template-dropdown d-block text-decoration-none"
                      [ngClass]="{'disable-dropdown': !projectMeta['allow_influencers_to_use_ai_avatar_in_widget'] || (widgetAIAvatarTemplates.length === 0) || !projectMeta['active']}">
                    <div class="dropdown-toggle d-flex align-items-center p-3" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                      <div class="d-flex align-items-center w-100" *ngIf="projectMeta['widget_ai_avatar_template'] && selectedWidgetAIAvatarTemplate; else noWidgetAITemplate">
                        <div class="avatar-image mr-2">
                          <img class="h-100 img-fluid" [src]="selectedWidgetAIAvatarTemplate?.selectedImageVariation?.url" />
                        </div>
                        <span class="text-wrap">{{selectedWidgetAIAvatarTemplate?.name}}</span>
                      </div>
                      <ng-template #noWidgetAITemplate>
                        <span>Select Widget AI Avatar Template</span>
                      </ng-template>
                    </div>
                    <div class="dropdown-menu avatar-template-list-dropdown w-100">
                      <div class="avatar-template-list-option">
                        <div *ngFor="let template of widgetAIAvatarTemplates" class="dropdown-item">
                          <div class="image-wrapper d-flex align-items-center pointer" (click)="selectWidgetAIAvatarTemplate(template)">
                            <div class="avatar-image mr-2">
                              <img class="h-100 img-fluid" [src]="template?.selectedImageVariation?.url" alt="{{template?.name}}" title="{{template?.name}}" />
                            </div>
                            <span class="text-wrap">{{template?.name}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <button class="btn customize-btn" type="button" role="button" (click)="showCustomizeAvatarTemplatePopup()" [disabled]="!projectMeta['active']">
                <span class="btn-wrapper--icon"><i class="fa fa-picture-o" aria-hidden="true"></i></span>
                <span class="btn-wrapper--label">Customize</span>
              </button>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>Test</legend>
          <div class='row'>
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="text-info">While you're adding the widget to your site, you may want to hide it from your users.</div>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class='input-group input-group-sm'>
                <input id="limit_access" placeholder="" type="checkbox"
                       [(ngModel)]="projectMeta['whitelist_access']" [disabled]="!projectMeta['active'] || isGlobalSettingInherited('whitelist_access')" (change)="changeCheckBox($event)">
                <label for="limit_access" style="margin-left: 5px; margin-top: 0; margin-right: 8px; margin-bottom: 0">Limit access for testing purpose</label>
                <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'whitelist_access'}"></ng-container>
              </div>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Opening the following URL adds your IP to the whitelist, this way the widget will only show up on your site when you're visiting</small>
              </div>
              <div class='input-group input-group-sm'>
                <input id="autoAddId" placeholder="" type="checkbox"
                       [(ngModel)]="projectMeta['auto_add_ip']" [disabled]="!projectMeta['active'] || !projectMeta['whitelist_access'] || isGlobalSettingInherited('auto_add_ip')">
                <label for="autoAddId" style="margin-left: 5px;margin-top: 8px;margin-right: 8px;">Enable Adding IP By Opening This URL: </label>
                <input class="form-control" [value]="ipLimitUrl" [readOnly]="true" style="margin-top: 5px;"/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'auto_add_ip'}"></ng-container>
            </div>
          </div>

          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Whitelisted IPs, only people coming from the following IPs can see the widget. clear it to let everyone see the widget (Separate by enter)</small>
              </div>
              <div class='input-group input-group-sm variable-textarea'>
                <textarea class="form-control" placeholder="34.54.54.66&#10;44.33.123.45" rows="5" [(ngModel)]="projectMeta['limit_access_ips']"
                          [disabled]="!projectMeta['active'] || !projectMeta['whitelist_access'] || isGlobalSettingInherited('limit_access_ips')">{{projectMeta['limit_access_ips']}}</textarea>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'limit_access_ips'}"></ng-container>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <legend>Visual</legend>
          <div class='row'>
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="text-info">Customize widget's look and feel. If you want to see the result you can just click on the Save button at the buttom and then click on Preview</div>
            </div>
          </div>
          <div class='row' style="display: none">
            <div class='col-md-11 mx-auto customize-email'>
              <input id="enable_linkedin_integration_before_registration" placeholder="" type="checkbox"
                     [disabled]="!projectMeta['active']"
                     [(ngModel)]="projectMeta['enable_linkedin_integration_before_registration']">
              <label for="enable_linkedin_integration_before_registration">Enable Linkedin Integration before registration</label>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <app-sb-input-language
                label="Language"
                id="language"
                [clearable]="false"
                [disabled]="!projectMeta['active'] || isGlobalSettingInherited('language')"
                [(ngModel)]="projectMeta['language']">
              </app-sb-input-language>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'language'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="widget-text-editor-label-row">
                <small class="text-capitalize">Header 1</small>
                <div class="inputs">
                  <app-variables
                    [isDisabled]="!projectMeta['active'] || isGlobalSettingInherited('header_1')"
                    [variableClickFor]="'header_1'"
                    (onVariableClick)="onWidgetTextEditorVariableClick($event, 'header_1', projectHeader1Editor)"
                  ></app-variables>
                  <app-file-browser
                    [clientId]="project?.client_id"
                    [projectId]="project?.id"
                    [enableChoose]="true"
                    [disabled]="!projectMeta['active'] || isGlobalSettingInherited('header_1')"
                    (fileSelected)="onWidgetTextEditorFileSelected($event, 'header_1')">
                  </app-file-browser>
                </div>
              </div>
              <ckeditor
                #projectHeader1Editor
                class="share-widget-text-editor share-widget-text-editor-compact"
                [config]="getWidgetTextEditorConfig('header_1')"
                [data]="projectMeta['header_1'] || ''"
                [readOnly]="!projectMeta['active'] || isGlobalSettingInherited('header_1')"
                (namespaceLoaded)="configureWidgetTextEditorNamespace($event)"
                (ready)="configureWidgetTextEditorOutput($event)"
                (dataChange)="onWidgetTextEditorChange('header_1', $event)">
              </ckeditor>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'header_1'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="widget-text-editor-label-row">
                <small class="text-capitalize">Header 2</small>
                <div class="inputs">
                  <app-variables
                    [isDisabled]="!projectMeta['active'] || isGlobalSettingInherited('header_2')"
                    [variableClickFor]="'header_2'"
                    (onVariableClick)="onWidgetTextEditorVariableClick($event, 'header_2', projectHeader2Editor)"
                  ></app-variables>
                  <app-file-browser
                    [clientId]="project?.client_id"
                    [projectId]="project?.id"
                    [enableChoose]="true"
                    [disabled]="!projectMeta['active'] || isGlobalSettingInherited('header_2')"
                    (fileSelected)="onWidgetTextEditorFileSelected($event, 'header_2')">
                  </app-file-browser>
                </div>
              </div>
              <ckeditor
                #projectHeader2Editor
                class="share-widget-text-editor share-widget-text-editor-compact"
                [config]="getWidgetTextEditorConfig('header_2')"
                [data]="projectMeta['header_2'] || ''"
                [readOnly]="!projectMeta['active'] || isGlobalSettingInherited('header_2')"
                (namespaceLoaded)="configureWidgetTextEditorNamespace($event)"
                (ready)="configureWidgetTextEditorOutput($event)"
                (dataChange)="onWidgetTextEditorChange('header_2', $event)">
              </ckeditor>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'header_2'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="widget-text-editor-label-row">
                <small class="text-capitalize">Header 3</small>
                <div class="inputs">
                  <app-variables
                    [isDisabled]="!projectMeta['active'] || isGlobalSettingInherited('header_3')"
                    [variableClickFor]="'header_3'"
                    (onVariableClick)="onWidgetTextEditorVariableClick($event, 'header_3', projectHeader3Editor)"
                  ></app-variables>
                  <app-file-browser
                    [clientId]="project?.client_id"
                    [projectId]="project?.id"
                    [enableChoose]="true"
                    [disabled]="!projectMeta['active'] || isGlobalSettingInherited('header_3')"
                    (fileSelected)="onWidgetTextEditorFileSelected($event, 'header_3')">
                  </app-file-browser>
                </div>
              </div>
              <ckeditor
                #projectHeader3Editor
                class="share-widget-text-editor share-widget-text-editor-compact"
                [config]="getWidgetTextEditorConfig('header_3')"
                [data]="projectMeta['header_3'] || ''"
                [readOnly]="!projectMeta['active'] || isGlobalSettingInherited('header_3')"
                (namespaceLoaded)="configureWidgetTextEditorNamespace($event)"
                (ready)="configureWidgetTextEditorOutput($event)"
                (dataChange)="onWidgetTextEditorChange('header_3', $event)">
              </ckeditor>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'header_3'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="widget-text-editor-label-row">
                <small class="text-capitalize">Promo Text</small>
              </div>
              <ckeditor
                #projectPromoTextEditor
                class="share-widget-text-editor"
                [config]="getWidgetTextEditorConfig('promo_text')"
                [data]="projectMeta['promo_text'] || ''"
                [readOnly]="!projectMeta['active'] || isGlobalSettingInherited('promo_text')"
                (namespaceLoaded)="configureWidgetTextEditorNamespace($event)"
                (ready)="configureWidgetTextEditorOutput($event)"
                (dataChange)="onWidgetTextEditorChange('promo_text', $event)">
              </ckeditor>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'promo_text'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Custom Minimized Text</small>
              </div>
              <div class='input-group input-group-sm variable-input'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('open_message_text')"
                       [(ngModel)]="projectMeta['open_message_text']" placeholder="Invite someone!"/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'open_message_text'}"></ng-container>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mx-auto customize-email'>
              <input id="minimized_notification_message_disabled" placeholder="" type="checkbox"
                     [(ngModel)]="projectMeta['minimized_notification_message_disabled']" [disabled]="!projectMeta['active'] || isGlobalSettingInherited('minimized_notification_message_disabled')">
              <label for="minimized_notification_message_disabled">Disable Minimized Notification Message</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'minimized_notification_message_disabled'}"></ng-container>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mx-auto customize-email'>
              <input id="hide_when_closed" placeholder="" type="checkbox"
                     [(ngModel)]="projectMeta['hide_when_closed']" [disabled]="!projectMeta['active'] || isGlobalSettingInherited('hide_when_closed')">
              <label for="hide_when_closed">Hide when closed</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'hide_when_closed'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Custom Minimized Notification Message</small>
              </div>
              <div class='input-group input-group-sm variable-input'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('minimized_notification_message')"
                       [(ngModel)]="projectMeta['minimized_notification_message']" placeholder="Click/Touch to easily invite others"/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'minimized_notification_message'}"></ng-container>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mx-auto customize-email'>
              <input id="user_agreement_checkbox_disabled" placeholder="" type="checkbox" value="true"
                     [(ngModel)]="projectMeta['user_agreement_checkbox_disabled']" [disabled]="!projectMeta['active'] || isGlobalSettingInherited('user_agreement_checkbox_disabled')">
              <label for="user_agreement_checkbox_disabled">Disable User Agreement Checkbox</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'user_agreement_checkbox_disabled'}"></ng-container>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mx-auto customize-email'>
              <input id="show_preload" placeholder="" type="checkbox" value="true"
                     [(ngModel)]="projectMeta['show_preload']" [disabled]="!projectMeta['active'] || isGlobalSettingInherited('show_preload')">
              <label for="show_preload">Show Preload</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'show_preload'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Display Mode</small>
              </div>
              <div class='input-group input-group-sm variable-input'>
                <select id="display_mode" class="widget-setting-select"
                        [(ngModel)]="projectMeta['display_mode']"
                        [disabled]="!projectMeta['active'] || isGlobalSettingInherited('display_mode')"
                        [value]="projectMeta['display_mode']">
                  <option value="popup">Popup</option>
                  <option value="popup_minimized">Minimized Popup</option>
                  <option value="embedded">Embedded</option>
                  <option value="hidden">Hidden</option>
                </select>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'display_mode'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Display State</small>
              </div>
              <div class='input-group input-group-sm variable-input'>
                <select id="display_mode_state" class="widget-setting-select"
                        [(ngModel)]="projectMeta['display_mode_state']"
                        [disabled]="!projectMeta['active'] || isGlobalSettingInherited('display_mode_state')">
                  <option value="">Default</option>
                  <option value="minimized">Minimized</option>
                  <option value="expanded">Expanded</option>
                </select>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'display_mode_state'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Linkedin Share Method</small>
              </div>
              <div class='input-group input-group-sm variable-input'>
                <select id="linkedin_share_method" class="widget-setting-select"
                        [(ngModel)]="projectMeta['linkedin_share_method']"
                        [disabled]="!projectMeta['active'] || isGlobalSettingInherited('linkedin_share_method')"
                        [value]="projectMeta['linkedin_share_method'] || 'basic'">
                  <option value="basic">Basic</option>
                  <option value="authenticated">Authenticated</option>
                </select>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'linkedin_share_method'}"></ng-container>
            </div>
          </div>
          <div class="row" *ngIf="false">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">TikTok Share Method</small>
              </div>
              <div class='input-group input-group-sm variable-input'>
                <select id="tiktok_share_method" [(ngModel)]="projectMeta['tiktok_share_method']" [disabled]="!projectMeta['active']" [value]="projectMeta['tiktok_share_method'] || 'basic'">
                  <option value="basic">Basic</option>
                  <option value="authenticated">Authenticated</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Default Texts Color</small>
              </div>
              <div class='input-group input-group-sm variable-input custom-color-picker'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('theme_color_1')" [value]="projectMeta['theme_color_1']"
                       [(ngModel)]="projectMeta['theme_color_1']" (change)="projectMeta['theme_color_1'] = $event.target.value" placeholder="#333399" appColorPicker/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'theme_color_1'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Background Color</small>
              </div>
              <div class='input-group input-group-sm variable-input custom-color-picker'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('theme_color_2')" [value]="projectMeta['theme_color_2']"
                       [(ngModel)]="projectMeta['theme_color_2']" (change)="projectMeta['theme_color_2'] = $event.target.value" placeholder="#FFFFFF" appColorPicker/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'theme_color_2'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Icons Color</small>
              </div>
              <div class='input-group input-group-sm variable-input custom-color-picker'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('theme_color_3')" [value]="projectMeta['theme_color_3']"
                       [(ngModel)]="projectMeta['theme_color_3']" (change)="projectMeta['theme_color_3'] = $event.target.value" placeholder="#333399" appColorPicker/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'theme_color_3'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Icons background color</small>
              </div>
              <div class='input-group input-group-sm variable-input custom-color-picker'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('theme_color_4')" [value]="projectMeta['theme_color_4']"
                       [(ngModel)]="projectMeta['theme_color_4']" (change)="projectMeta['theme_color_4'] = $event.target.value" placeholder="#e1e2e7" appColorPicker/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'theme_color_4'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Close Window Icon Color</small>
              </div>
              <div class='input-group input-group-sm variable-input custom-color-picker'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('theme_color_5')" [value]="projectMeta['theme_color_5']"
                       [(ngModel)]="projectMeta['theme_color_5']" (change)="projectMeta['theme_color_5'] = $event.target.value" placeholder="#8a8a8a" appColorPicker/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'theme_color_5'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Textarea Border color</small>
              </div>
              <div class='input-group input-group-sm variable-input custom-color-picker'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('theme_color_6')" [value]="projectMeta['theme_color_6']"
                       [(ngModel)]="projectMeta['theme_color_6']" (change)="projectMeta['theme_color_6'] = $event.target.value" placeholder="#cacaca" appColorPicker/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'theme_color_6'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Textarea text color</small>
              </div>
              <div class='input-group input-group-sm variable-input custom-color-picker'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('theme_color_7')" [value]="projectMeta['theme_color_7']"
                       [(ngModel)]="projectMeta['theme_color_7']" (change)="projectMeta['theme_color_7'] = $event.target.value" placeholder="#000000" appColorPicker/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'theme_color_7'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Textarea Background Color</small>
              </div>
              <div class='input-group input-group-sm variable-input custom-color-picker'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('theme_color_8')" [value]="projectMeta['theme_color_8']"
                       [(ngModel)]="projectMeta['theme_color_8']" (change)="projectMeta['theme_color_8'] = $event.target.value" placeholder="#ffffff" appColorPicker/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'theme_color_8'}"></ng-container>
            </div>
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Minimized Text Color</small>
              </div>
              <div class='input-group input-group-sm variable-input custom-color-picker'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('theme_color_9')" [value]="projectMeta['theme_color_9']"
                       [(ngModel)]="projectMeta['theme_color_9']" (change)="projectMeta['theme_color_9'] = $event.target.value" placeholder="#ffffff" appColorPicker/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'theme_color_9'}"></ng-container>
            </div>
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Minimized Background Color</small>
              </div>
              <div class='input-group input-group-sm variable-input custom-color-picker'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('theme_color_10')" [value]="projectMeta['theme_color_10']"
                       [(ngModel)]="projectMeta['theme_color_10']" (change)="projectMeta['theme_color_10'] = $event.target.value" placeholder="#333399" appColorPicker/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'theme_color_10'}"></ng-container>
            </div>
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Minimized Border Color</small>
              </div>
              <div class='input-group input-group-sm variable-input custom-color-picker'>
                <input class="form-control" type='text' [disabled]="!projectMeta['active'] || isGlobalSettingInherited('theme_color_11')" [value]="projectMeta['theme_color_11']"
                       [(ngModel)]="projectMeta['theme_color_11']" (change)="projectMeta['theme_color_11'] = $event.target.value" placeholder="#e1e2e7" appColorPicker/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'theme_color_11'}"></ng-container>
            </div>
          </div>
          <!--
          <div class='row'>
            <div class='col-md-11 mb-3 mx-auto'>
              <label for='font_family'><small>Font</small></label>
              <div class='input-group input-group-sm'>
                <input value="{{projectMeta['font_family'] || ''}}" id="font_family" appFontPicker
                       [disabled]="!projectMeta['active'] || isGlobalSettingInherited('font_face')"
                       class='form-control' (change)="projectMeta['font_family'] = $event.target.value"
                       type='text' />
              </div>
            </div>
          </div>
          -->
          <div class='row'>
            <div class='col-md-11 mb-3 mx-auto'>
              <label for="fontface"><small>Custom FontFace</small></label>
              <div class='input-group input-group-sm'>
                <textarea id="fontface" class='form-control' placeholder="@font-face {
  font-family: myFirstFont;
  src: url(https://example.com/sansation_light.woff);
}" (change)="projectMeta['fontface'] = $event.target.value"
                       data-field='fontface' data-unit="px"
                          value="{{projectMeta['fontface'] || ''}}" rows="8"></textarea>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'font_face'}"></ng-container>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mb-3 mx-auto'>
              <label for="font_family"><small>Font Family</small></label>
              <div class='input-group input-group-sm'>
                <input id="font_family" style="height: 36px;" class='form-control'
                       [disabled]="!projectMeta['active'] || isGlobalSettingInherited('font_family')"
                       (change)="projectMeta['font_family'] = $event.target.value"
                       data-field='font_size' data-unit="px" placeholder="'myFirstFont', 'omnes', Arial, 'Helvetica Neue', Helvetica, sans-serif"
                       value="{{projectMeta['font_family'] || ''}}"/>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'font_family'}"></ng-container>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mb-3 mx-auto language-fonts'>
              <label><small>Language-specific fonts</small></label>
              <div class="text-info mb-2">
                Optional. Use a different font when the widget renders in a given language &mdash;
                useful when your brand font has no glyphs for that script. Languages not listed here
                use the Font Family above. If the font is not a system font, declare its
                &#64;font-face once in Custom FontFace above.
              </div>
              <div class="language-font-row mb-3" *ngFor="let languageFont of languageFonts; let i = index">
                <div class="d-flex align-items-start">
                  <div class="flex-fill mr-2">
                    <app-sb-input-language
                      label="Language"
                      [id]="'language_font_' + i"
                      [disabled]="!projectMeta['active'] || isGlobalSettingInherited('font_by_language')"
                      [(ngModel)]="languageFont.language">
                    </app-sb-input-language>
                  </div>
                  <div class="flex-fill mr-2">
                    <app-sb-input-text
                      label="Font Family"
                      [id]="'language_font_family_' + i"
                      [disabled]="!projectMeta['active'] || isGlobalSettingInherited('font_by_language')"
                      placeholder="'Noto Sans JP', sans-serif"
                      [(ngModel)]="languageFont.font_family">
                    </app-sb-input-text>
                  </div>
                  <app-sb-button
                    class="language-font-remove"
                    variant="ghost"
                    size="sm"
                    shape="circle"
                    icon="fa fa-trash"
                    extraClass="text-danger"
                    ariaLabel="Remove language-specific font"
                    [disabled]="!projectMeta['active'] || isGlobalSettingInherited('font_by_language')"
                    (clicked)="removeLanguageFont(i)">
                  </app-sb-button>
                </div>
                <div class="text-danger small mt-1" *ngIf="isDuplicateLanguageFont(i)">
                  This language is already configured above &mdash; only the first entry is used.
                </div>
              </div>
              <button type="button" class="btn btn-default btn-sm"
                      [disabled]="!projectMeta['active'] || isGlobalSettingInherited('font_by_language')"
                      (click)="addLanguageFont()">
                <i class="fa fa-plus"></i> Add language
              </button>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'font_by_language'}"></ng-container>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mb-3 mx-auto'>
              <label for="font_size"><small>Font Size</small></label>
              <div class='input-group input-group-sm'>
                <input id="font_size" style="height: 36px;" class='form-control' type='number' placeholder="1"
                       [disabled]="!projectMeta['active'] || isGlobalSettingInherited('font_size')" (change)="projectMeta['font_size'] = $event.target.value"
                       data-field='font_size' data-unit="px"
                       value="{{projectMeta['font_size'] || ''}}"/>
                <div class='input-group-append'>
                  <span class='input-group-text'>px</span>
                </div>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'font_size'}"></ng-container>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mx-auto customize-email'>
              <input id="show_widget_ui_customization_on_all_widgets" placeholder="" type="checkbox" value="true"
                     [(ngModel)]="projectMeta['show_widget_ui_customization_on_all_widgets']" [disabled]="!projectMeta['active'] || isGlobalSettingInherited('show_widget_ui_customization_on_all_widgets')">
              <label for="show_preload">Show widget UI customization on all widgets</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'show_widget_ui_customization_on_all_widgets'}"></ng-container>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mx-auto customize-email'>
              <input id="enable_joined_influencer_cookie" placeholder="" type="checkbox"
                     [(ngModel)]="projectMeta['enable_joined_influencer_cookie']" [disabled]="!projectMeta['active'] || projectMeta['display_mode'] === 'hidden' || isGlobalSettingInherited('enable_joined_influencer_cookie')">
              <label for="enable_joined_influencer_cookie">Show the minimized widget on the site user previously joined via widget</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'enable_joined_influencer_cookie'}"></ng-container>
            </div>
          </div>
        </fieldset>
        <fieldset *ngIf="currentUser?.can( 'view-client-column', 'project-ui') && !globalWidget">
          <legend>Advanced</legend>
          <div class='row'>
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="text-info">This is for more advanced customization and integration. Such as when the widget doesn't work or your site needs special customization for the widget to work</div>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mx-auto customize-email'>
              <input id="referral_append_query_string_to_all_links" placeholder="" type="checkbox"
                     [(ngModel)]="projectMeta['referral_append_query_string_to_all_links']" [disabled]="!projectMeta['active'] || isGlobalSettingInherited('referral_append_query_string_to_all_links')">
              <label for="referral_append_query_string_to_all_links">Add the referral tracking parameter to other links on the page</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'referral_append_query_string_to_all_links'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Auto add referral allowed domains (Separate by enter. Leave blank to disable this feature)</small>
              </div>
              <div class='input-group input-group-sm variable-textarea'>
                <textarea class="form-control" placeholder="example.com&#10;test.example.com&#10;*.example.com&#10;exampe*.com" rows="5" [(ngModel)]="projectMeta['referral_allowed_domains']"
                          [disabled]="!projectMeta['active'] || !projectMeta['referral_append_query_string_to_all_links'] || isGlobalSettingInherited('referral_allowed_domains')">{{projectMeta['referral_allowed_domains']}}</textarea>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'referral_allowed_domains'}"></ng-container>
            </div>
          </div>
          <div class='row' *ngFor="let toggle of widgetBehaviorToggles">
            <div class='col-md-11 mx-auto customize-email'>
              <input [id]="toggle.key" placeholder="" type="checkbox"
                     [(ngModel)]="projectMeta[toggle.key]" [disabled]="!projectMeta['active']">
              <label [for]="toggle.key">{{toggle.label}}</label>
            </div>
          </div>
          <div class="row" *ngIf="currentUser?.can( 'view-client-column', 'project-ui')">
            <div class="col-md-11 mx-auto customize-email">
              <input id="remoteLog" placeholder="" type="checkbox"
                     [(ngModel)]="projectMeta['google_analytics_disabled']" [disabled]="!projectMeta['active'] || isGlobalSettingInherited('google_analytics_disabled')">
              <label for="remoteLog">Disable Google Analytics Tracking For Embedded Widget Visits</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'google_analytics_disabled'}"></ng-container>
            </div>
          </div>           
          <div class='row'>
            <div class='col-md-11 mx-auto customize-email'>
              <input id="remoteLog" placeholder="" type="checkbox"
                     [(ngModel)]="remoteLogEnabled" [disabled]="!projectMeta['active'] || isGlobalSettingInherited('remote_log_disabled')">
              <label for="remoteLog">Remote Log</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'remote_log_disabled'}"></ng-container>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mx-auto customize-email'>
              <input id="debug" placeholder="" type="checkbox"
                     [(ngModel)]="projectMeta['debug']" [disabled]="!projectMeta['active'] || isGlobalSettingInherited('debug')">
              <label for="debug">Debug</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'debug'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div *ngIf="currentUser?.can( 'view-client-column', 'project-ui') && widgetCustomizationCode && this.projectMeta['registration_platform_id']" class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Platform's Default Script</small>
              </div>
              <div class='input-group input-group-sm variable-input'>
                <textarea class="form-control auto-grow-textarea"
                          id="widget_code" placeholder="" type="text" readonly="readonly" rows="10">{{widgetCustomizationCode}}
                </textarea>
              </div>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mx-auto customize-email'>
              <input id="registration_platform_default_custom_js" placeholder="" type="checkbox"
                     [(ngModel)]="projectMeta['registration_platform_default_custom_js']" [disabled]="!projectMeta['active'] || isGlobalSettingInherited('registration_platform_default_custom_js')">
              <label for="registration_platform_default_custom_js">Use registration platform's default script</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'registration_platform_default_custom_js'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Custom Script</small>

                <a class="email-verification-button ml-1" style="color: #4BB7E3; cursor: pointer"
                 (click)="showCustomScriptInstructions(widgetCustomScriptInstructions)">
                  <i class="fa fa-question-circle"></i>
                  View Guide
                </a>
              </div>
              <div class='input-group input-group-sm'>
                <ace-editor #editor style="min-height: 200px;"
                            [autoUpdateContent]="true"
                            [mode]="'javascript'"
                            [options]="aceEditorOptions"
                            [(text)]="projectMeta[customScriptKey]"
                            [readOnly]="!projectMeta['active'] || isGlobalSettingInherited('custom_script')">
                </ace-editor>
              </div>
              <div *ngIf="canGenerateWidgetCustomization">
                <button class="btn btn-sm btn-primary mt-1" type="button"
                        (click)="openWidgetCustomizationAi()">
                  <i class="fa fa-magic mr-1"></i>
                  Generate with AI
                </button>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'custom_script'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div *ngIf="currentUser?.can( 'view-client-column', 'project-ui') && widgetCustomizationCss && this.projectMeta['registration_platform_id']" class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Platform's Default Css</small>
              </div>
              <div class='input-group input-group-sm variable-input'>
                <textarea class="form-control auto-grow-textarea"
                          id="widget_css" placeholder="" type="text" readonly="readonly" rows="10">{{widgetCustomizationCss}}
                </textarea>
              </div>
            </div>
          </div>
          <div class='row'>
            <div class='col-md-11 mx-auto customize-email'>
              <input id="registration_platform_default_custom_css" placeholder="" type="checkbox"
                     [(ngModel)]="projectMeta['registration_platform_default_custom_css']" [disabled]="!projectMeta['active'] || isGlobalSettingInherited('registration_platform_default_custom_css')">
              <label for="registration_platform_default_custom_css">Use registration platform's default CSS</label>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'registration_platform_default_custom_css'}"></ng-container>
            </div>
          </div>
          <div class="row">
            <div class='col-md-11 mb-3 mx-auto'>
              <div class="d-flex align-items-center">
                <small class="text-capitalize">Custom CSS</small>
              </div>
              <div class='input-group input-group-sm variable-textarea'>
                <div [attr.data-replicated-value]="projectMeta[customCssKey]" class="grow-wrap" style="width: 100%">
                <textarea onInput="this.parentNode.dataset.replicatedValue = this.value" class="form-control" rows="10" [(ngModel)]="projectMeta[customCssKey]"
                          [disabled]="!projectMeta['active'] || isGlobalSettingInherited('custom_css')">{{projectMeta[customCssKey]}}</textarea>
                </div>
              </div>
              <div *ngIf="canGenerateWidgetCustomization">
                <button class="btn btn-sm btn-primary mt-1" type="button"
                        (click)="openWidgetCustomizationAi()">
                  <i class="fa fa-magic mr-1"></i>
                  Generate with AI
                </button>
              </div>
              <ng-container *ngTemplateOutlet="useGlobalSetting; context: {key: 'custom_css'}"></ng-container>
            </div>
          </div>
        </fieldset>
        <ng-template sbInputFormActions>
          <div class="sb-form__footer-actions">
            <app-sb-button variant="default" label="Preview" icon="fa fa-eye" type="button"
              [disabled]="!projectMeta['active']" (clicked)="previewWidget()"></app-sb-button>
            <app-sb-button *ngIf="currentUser?.can('view-client-column', 'project-ui')"
              variant="default" label="Start Widget Integration Assistant Session" icon="fa fa-comments" type="button"
              [disabled]="!projectMeta['active']" (clicked)="startWidgetIntegrationAssistantSession()"></app-sb-button>
            <app-sb-button variant="primary" label="Save" icon="fa fa-check" type="button"
              (clicked)="shareWidgetPreview()"></app-sb-button>
          </div>
        </ng-template>
      </app-sb-input-form>

</div>
</app-page-shell>

<ng-template #advancedImageSettingsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Advanced Image Settings</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h6 class="text-uppercase text-muted font-weight-bold mb-3">Size</h6>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Min Width</label>
          <div class="input-group">
          <input type="number"
                 min="0"
                 class="form-control"
                 [(ngModel)]="projectMeta['widget_profile_picture_min_width']"
                 placeholder="0">
            <div class="input-group-append">
              <span class="input-group-text">px</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Min Height</label>
          <div class="input-group">
          <input type="number"
                 min="0"
                 class="form-control"
                 [(ngModel)]="projectMeta['widget_profile_picture_min_height']"
                 placeholder="10">
            <div class="input-group-append">
              <span class="input-group-text">px</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <app-sb-button variant="default" label="Cancel" icon="fa fa-times" type="button" (clicked)="modal.dismiss('cancel')"></app-sb-button>
    <app-sb-button variant="primary" label="Save Settings" icon="fa fa-check" type="button" (clicked)="saveWidgetAdvancedSettings(modal)"></app-sb-button>
  </div>
</ng-template>

<ng-template #advancedVideoSettingsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Advanced Video Settings</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h6 class="text-uppercase text-muted font-weight-bold mb-3">Recording</h6>
    <div class="form-group">
      <input id="project_widget_profile_video_enable_recorder"
             type="checkbox"
             class="styled-checkbox"
             [(ngModel)]="projectMeta['widget_profile_video_enable_recorder']">
      <label for="project_widget_profile_video_enable_recorder" class="ml-1">Enable Recorder</label>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Min Duration</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="projectMeta['widget_profile_video_min_duration']" placeholder="0">
            <div class="input-group-append">
              <span class="input-group-text">sec</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Max Duration</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="projectMeta['widget_profile_video_max_duration']" placeholder="10">
            <div class="input-group-append">
              <span class="input-group-text">sec</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Min Width</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="projectMeta['widget_profile_video_min_width']" placeholder="0">
            <div class="input-group-append">
              <span class="input-group-text">px</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Min Height</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="projectMeta['widget_profile_video_min_height']" placeholder="0">
            <div class="input-group-append">
              <span class="input-group-text">px</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Target Aspect Width</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="projectMeta['widget_profile_video_target_aspect_width']" placeholder="0">
            <div class="input-group-append">
              <span class="input-group-text">ratio</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Target Aspect Height</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="projectMeta['widget_profile_video_target_aspect_height']" placeholder="0">
            <div class="input-group-append">
              <span class="input-group-text">ratio</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="projectMeta['widget_profile_video_enable_recorder']">
    <h6 class="text-uppercase text-muted font-weight-bold mb-3 mt-3">Captions</h6>
    <div class="form-group">
      <label class="d-block">Caption Mode</label>
      <div class="form-check form-check-inline">
        <input id="project_caption_mode_auto"
               class="form-check-input"
               type="radio"
               name="project_caption_mode"
               value="auto"
               [(ngModel)]="projectMeta['widget_profile_video_caption_mode']">
        <label class="form-check-label" for="project_caption_mode_auto">Auto</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="project_caption_mode_let_user_decide"
               class="form-check-input"
               type="radio"
               name="project_caption_mode"
               value="let_user_decide"
               [(ngModel)]="projectMeta['widget_profile_video_caption_mode']">
        <label class="form-check-label" for="project_caption_mode_let_user_decide">Let user decide</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="project_caption_mode_disabled"
               class="form-check-input"
               type="radio"
               name="project_caption_mode"
               value="disabled"
               [(ngModel)]="projectMeta['widget_profile_video_caption_mode']">
        <label class="form-check-label" for="project_caption_mode_disabled">Disabled</label>
      </div>
    </div>
    <div class="row" *ngIf="projectMeta['widget_profile_video_caption_mode'] !== 'disabled'">
      <div class="col-md-12">
        <div class="form-group">
          <label>Caption Font</label>
          <div class="input-group">
            <input type="text"
                   class="form-control"
                   [value]="getVideoCaptionFontLabel(projectMeta)"
                   readonly>
            <div class="input-group-append">
              <button type="button"
                      class="btn btn-default"
                      (click)="openVideoCaptionFontBrowser(projectMeta, widgetVideoCaptionFontBrowserModal)">
                Browse
              </button>
              <button type="button"
                      class="btn btn-default"
                      (click)="clearVideoCaptionFont(projectMeta)">
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="d-block">Caption Position</label>
          <div class="form-check form-check-inline">
            <input id="project_caption_position_top"
                   class="form-check-input"
                   type="radio"
                   name="project_caption_position"
                   value="top"
                   [(ngModel)]="projectMeta['widget_profile_video_caption_position']">
            <label class="form-check-label" for="project_caption_position_top">Top</label>
          </div>
          <div class="form-check form-check-inline">
            <input id="project_caption_position_center"
                   class="form-check-input"
                   type="radio"
                   name="project_caption_position"
                   value="center"
                   [(ngModel)]="projectMeta['widget_profile_video_caption_position']">
            <label class="form-check-label" for="project_caption_position_center">Middle</label>
          </div>
          <div class="form-check form-check-inline">
            <input id="project_caption_position_bottom"
                   class="form-check-input"
                   type="radio"
                   name="project_caption_position"
                   value="bottom"
                   [(ngModel)]="projectMeta['widget_profile_video_caption_position']">
            <label class="form-check-label" for="project_caption_position_bottom">Bottom</label>
          </div>
        </div>
        <div class="form-group">
          <input id="project_widget_profile_video_caption_background_enabled"
                 type="checkbox"
                 class="styled-checkbox"
                 [(ngModel)]="projectMeta['widget_profile_video_caption_background_enabled']">
          <label for="project_widget_profile_video_caption_background_enabled" class="ml-1">Enable Caption Background</label>
        </div>
      </div>
      <div class="col-md-6" *ngIf="projectMeta['widget_profile_video_caption_background_enabled']">
        <div class="form-group">
          <label>Caption Background Color</label>
          <div class="row">
            <div class="col-3 pr-1">
              <input type="color" class="form-control p-1" [(ngModel)]="projectMeta['widget_profile_video_caption_background_color']">
            </div>
            <div class="col-9 pl-1">
              <input type="text" class="form-control" [(ngModel)]="projectMeta['widget_profile_video_caption_background_color']">
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Opacity: {{projectMeta['widget_profile_video_caption_background_opacity']}}%</label>
          <input type="range"
                 class="custom-range"
                 min="0"
                 max="100"
                 [(ngModel)]="projectMeta['widget_profile_video_caption_background_opacity']">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Font Color</label>
          <div class="row">
            <div class="col-3 pr-1">
              <input type="color" class="form-control p-1" [(ngModel)]="projectMeta['widget_profile_video_caption_font_color']">
            </div>
            <div class="col-9 pl-1">
              <input type="text" class="form-control" [(ngModel)]="projectMeta['widget_profile_video_caption_font_color']">
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Opacity: {{projectMeta['widget_profile_video_caption_font_opacity']}}%</label>
          <input type="range"
                 class="custom-range"
                 min="0"
                 max="100"
                 [(ngModel)]="projectMeta['widget_profile_video_caption_font_opacity']">
        </div>
      </div>
    </div>

    <h6 class="text-uppercase text-muted font-weight-bold mb-3 mt-3">Background</h6>
    <div class="form-group">
      <label class="d-block">Background Mode</label>
      <div class="form-check form-check-inline">
        <input id="project_background_mode_auto"
               class="form-check-input"
               type="radio"
               name="project_background_mode"
               value="auto"
               [(ngModel)]="projectMeta['widget_profile_video_background_mode']">
        <label class="form-check-label" for="project_background_mode_auto">Auto</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="project_background_mode_let_user_decide"
               class="form-check-input"
               type="radio"
               name="project_background_mode"
               value="let_user_decide"
               [(ngModel)]="projectMeta['widget_profile_video_background_mode']">
        <label class="form-check-label" for="project_background_mode_let_user_decide">Let user decide</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="project_background_mode_disabled"
               class="form-check-input"
               type="radio"
               name="project_background_mode"
               value="disabled"
               [(ngModel)]="projectMeta['widget_profile_video_background_mode']">
        <label class="form-check-label" for="project_background_mode_disabled">Disabled</label>
      </div>
    </div>
    <div class="form-group" *ngIf="projectMeta['widget_profile_video_background_mode'] !== 'disabled'">
      <label>Background Color</label>
      <div class="row">
        <div class="col-2 pr-1">
          <input type="color" class="form-control p-1" [(ngModel)]="projectMeta['widget_profile_video_background_color']">
        </div>
        <div class="col-10 pl-1">
          <input type="text" class="form-control" [(ngModel)]="projectMeta['widget_profile_video_background_color']">
        </div>
      </div>
    </div>

    <h6 class="text-uppercase text-muted font-weight-bold mb-3 mt-3">Teleprompter</h6>
    <div class="form-group">
      <input id="project_widget_profile_video_enable_teleprompter"
             type="checkbox"
             class="styled-checkbox"
             [(ngModel)]="projectMeta['widget_profile_video_enable_teleprompter']">
      <label for="project_widget_profile_video_enable_teleprompter" class="ml-1">Enable Teleprompter</label>
    </div>
    <div class="form-group" *ngIf="projectMeta['widget_profile_video_enable_teleprompter']">
      <label>Speed: {{projectMeta['widget_profile_video_teleprompter_speed']}}ms</label>
      <div class="d-flex align-items-center">
        <span class="mr-2">100ms</span>
        <input type="range"
               class="custom-range"
               min="100"
               max="500"
               step="10"
               [(ngModel)]="projectMeta['widget_profile_video_teleprompter_speed']">
        <span class="ml-2">500ms</span>
      </div>
    </div>
    <div class="form-group mb-0" *ngIf="projectMeta['widget_profile_video_enable_teleprompter']">
      <label>Question</label>
      <textarea class="form-control"
                rows="4"
                [(ngModel)]="projectMeta['widget_profile_video_teleprompter_question']"
                placeholder="Write your questions here..."></textarea>
      <small class="form-text text-muted">Can only be used when teleprompter is enabled</small>
    </div>
    </ng-container>
  </div>
  <div class="modal-footer">
    <app-sb-button variant="default" label="Cancel" icon="fa fa-times" type="button" (clicked)="modal.dismiss('cancel')"></app-sb-button>
    <app-sb-button variant="primary" label="Save Settings" icon="fa fa-check" type="button" (clicked)="saveWidgetAdvancedSettings(modal)"></app-sb-button>
  </div>
</ng-template>

<ng-template #widgetVideoCaptionFontBrowserModal let-modal>
  <app-iframe-modal-shell
    #fontBrowserShell
    [src]="fontBrowserUrl"
    (close)="modal.dismiss('cancel')">
  </app-iframe-modal-shell>
  <app-file-browser
    #fontFileBrowser
    class="d-none"
    [projectId]="projectId"
    [type]="'font'"
    (fileSelected)="onFontBrowserFileSelected($event)">
  </app-file-browser>
</ng-template>

<ng-template #widgetInstructions let-modal>
  <div class="modal-header">
    <h4 class="modal-title d-flex align-items-center" id="modal-title">
      Widget integration instructions
      <span class="share-link ml-2">
    <a [href]="shareWidgetLinkUrl" target="_blank"><i class="fa fa-share"></i></a>
  </span>
    </h4>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="modal.dismiss('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-body--iframe">
<!--    <div *ngIf="widgetIntegrationBody" [innerHTML]="widgetIntegrationBody">-->
<!--    </div>-->
    <iframe class="widget-integration-frame"
      frameborder="0" width="100%" height="auto"
      *ngIf="widgetIntegrationUrl"
      [src]="widgetIntegrationUrl">
    </iframe>
  </div>
  <input type="hidden" ngbAutofocus>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.close()">Close</button>
  </div>
</ng-template>

<ng-template #widgetCustomScriptInstructions let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">Custom Script instructions</h4>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="modal.dismiss('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="widgetCustomScriptBody" [innerHTML]="widgetCustomScriptBody | sanitizeHtml: 'html'">
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.close()">Close</button>
  </div>
</ng-template>
